import { ref } from 'vue';

// 点击空白区域隐藏语言选择框
export function useHideLanguageOptions() {
  const i18nRef = ref();

  function hiddenLanguageOptions() {
    i18nRef.value.hiddenOptions(true);
  }

  return { i18nRef, hiddenLanguageOptions };
}
